<div class="container-fluid px-0">
    <div class="row">
        <div class="col-md-8">
            <!--<div class="d-flex">-->
            <div class="row">


                <div class="col-md-3 col-6 mb-4 mb-lg-0">
                    <div class="d-flex align-items-center mb-4 flex-lg-fill handcursor">

                        <img src="assets/common/images/Activities/noEmployeeactivity.svg" alt=""
                             class="mr-1 h-30px w-22px" />
                        <span class="font-size-nm font-weight-bolder  ml-1 mr-1" *ngIf="teamWorkingStatus"
                              style="color: #8cabff;">{{ teamWorkingStatus.totalNoOfEmployee}}</span>

                        <div class="d-flex flex-column text-dark-50">
                            <span>
                                <small class="mb-1 font-size-sm font-weight-bolder text-dark-50">{{'NoOfEmployees'|localize}}</small>
                            </span>
                            <ngx-shimmer-loading *ngIf="!teamWorkingStatus" [width]="'50px'"
                                                 [height]="'15px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6 mb-4 mb-lg-0">
                    <div class="d-flex align-items-center flex-lg-fill my-1 handcursor">

                        <img src="assets/common/images/Activities/wfo.svg" alt="" class="mr-1 h-22px w-22px" pTooltip="Work From Office" tooltipPosition="bottom" />
                        <span class="font-size-nm font-weight-bolder  ml-1 mr-1" *ngIf="teamWorkingStatus"
                              style="color: #8cabff;">{{teamWorkingStatus.workFromOfficeCount}}</span>

                        <div class="d-flex flex-column text-dark-50">
                            <span>
                                <small class="mb-1 font-size-sm font-weight-bolder text-dark-50">{{'WorkFromOffice'|localize}}</small>

                            </span>
                            <ngx-shimmer-loading *ngIf="!teamWorkingStatus" [width]="'50px'"
                                                 [height]="'15px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6 mb-4 mb-lg-0">
                    <div class="d-flex align-items-center flex-lg-fill my-1 handcursor">
                        <img src="assets/common/images/Activities/wfr.svg" alt="" class="mr-1 h-22px w-22px" pTooltip="Remote Working" tooltipPosition="bottom" />
                        <span class="font-size-nm font-weight-bolder  ml-1 mr-1" *ngIf="teamWorkingStatus"
                              style="color: #8cabff;">{{teamWorkingStatus.workFromRemote}}</span>
                        <div class="d-flex flex-column text-dark-50">
                            <span>
                                <small class="mb-1 font-size-sm font-weight-bolder text-dark-50">{{'RemoteWorking'|localize}}</small>
                            </span>
                            <ngx-shimmer-loading *ngIf="!teamWorkingStatus" [width]="'50px'"
                                                 [height]="'15px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                </div>

                <div class="col-md-2 col-6 mb-4 mb-lg-0">
                    <div class="d-flex align-items-center flex-lg-fill my-1 handcursor">

                        <img src="assets/common/images/Activities/Location-unknown.svg" alt="" class="mr-1 h-22px w-22px" pTooltip="Location Unavailable" tooltipPosition="bottom" />
                        <span class="font-size-nm font-weight-bolder  ml-1 mr-1" *ngIf="teamWorkingStatus"
                              style="color: #8cabff;">{{teamWorkingStatus.workFromUnkown}}</span>
                        <div class="d-flex flex-column text-dark-50">
                            <span>
                                <small class="mb-1 font-size-sm font-weight-bolder text-dark-50">{{'Nolocation'|localize}}</small>

                            </span>
                            <ngx-shimmer-loading *ngIf="!teamWorkingStatus" [width]="'50px'"
                                                 [height]="'15px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                </div>


                <div class="col-md-2 col-6 mb-4 mb-lg-0">
                    <div class="d-flex align-items-center flex-lg-fill my-1 handcursor">

                        <img src="assets/common/images/Activities/offlineemployee.svg" alt="" class="mr-1 h-22px w-22px" pTooltip="Offline Users" tooltipPosition="bottom" />
                        <span class="font-size-nm font-weight-bolder  ml-1 mr-1" *ngIf="teamWorkingStatus"
                              style="color: #8cabff;">{{teamWorkingStatus.offlineEmployeeCount}}</span>
                        <div class="d-flex flex-column text-dark-50">
                            <span>
                                <small class="mb-1 font-size-sm font-weight-bolder text-dark-50">{{'Offline'|localize}}</small>

                            </span>
                            <ngx-shimmer-loading *ngIf="!teamWorkingStatus" [width]="'50px'"
                                                 [height]="'15px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-md-4">
            <div class="d-flex h-50 justify-content-end">


                <!--Export button-->
                <export-dropdown *ngIf="isListView" class="ml-2" (onSelectionChange)="onExportButtonChangeEvent($event)"></export-dropdown>

                <!--Filter Button-->
                <div class="ml-2" *ngIf="isListView">
                    <div id="export-btn">
                        <button type="button" class="export btn btn-icon btn-outline-danger h-40px rounded-0 exportBtn text-white tooltip-left cursor-pointer btn-export" tooltipPosition="bottom"
                                pTooltip="{{ 'Filter' | localize }}" (click)="searchbtnShowHide($event)">
                            <!--[disabled]="!dataSource?.length"-->
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36">
                                <g id="Filter" transform="translate(-116 -40)">
                                    <rect width="36" height="36" rx="4" stroke="none" />
                                    <rect x="0.5" y="0.5" width="35" height="35" rx="3.5" fill="none" />
                                    <path id="Filter-2" data-name="Filter"
                                          d="M13.314,15.75v-5l6.923-6.923a1.646,1.646,0,0,0,.513-1.282A1.753,1.753,0,0,0,18.955.75H2.545A1.753,1.753,0,0,0,.75,2.545a1.646,1.646,0,0,0,.513,1.282L8.186,10.75v10Z"
                                          transform="translate(123.25 47.25)" fill="none" stroke="#de285a" stroke-linecap="round"
                                          stroke-linejoin="round" stroke-miterlimit="1" stroke-width="1" />
                                </g>
                            </svg>
                        </button>
                    </div>

                </div>

                <!--Calendar Button-->
                <div id="datepickerId" *ngIf="isListView">
                    <button (click)="dp.show()" class="btn ml-2 btn-outline-danger h-40px rounded-0 text-white  p-0">
                        <span class="position-absolute Datepicker"
                              #dp="bsDatepicker"
                              bsDatepicker
                              [bsConfig]="{ showWeekNumbers:false }"
                              id="time-and-attendance-datepicker"
                              [bsValue]="selectedDate"
                              [maxDate]="maxDay" style="visibility: hidden; right: 25rem; top: 3.5rem;"
                              (bsValueChange)="selectViewCalendar('day', $event)"></span>
                        <button type="button" class="btn btn-icon h-40px" tooltipPosition="bottom"
                                pTooltip="{{ 'Calendar' | localize }}">

                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                <g id="Group_195400" data-name="Group 195400" transform="translate(-0.5)">
                                    <path id="Path_194421" data-name="Path 194421" d="M7.5,10.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-0.75 -1.909)" fill="#f64e60" />
                                    <path id="Path_194422" data-name="Path 194422" d="M12.5,10.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-1.5 -1.909)" fill="#f64e60" />
                                    <path id="Path_194423" data-name="Path 194423" d="M17.5,10.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-2.25 -1.909)" fill="#f64e60" />
                                    <path id="Path_194424" data-name="Path 194424" d="M7.5,14.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-0.75 -2.636)" fill="#f64e60" />
                                    <path id="Path_194425" data-name="Path 194425" d="M12.5,14.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-1.5 -2.636)" fill="#f64e60" />
                                    <path id="Path_194426" data-name="Path 194426" d="M17.5,14.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-2.25 -2.636)" fill="#f64e60" />
                                    <path id="Path_194427" data-name="Path 194427" d="M7.5,18.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-0.75 -4)" fill="#f64e60" />
                                    <path id="Path_194428" data-name="Path 194428" d="M12.5,18.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-1.5 -4)" fill="#f64e60" />
                                    <path id="Path_194429" data-name="Path 194429" d="M17.5,18.5h-1a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z" transform="translate(-2.25 -4)" fill="#f64e60" />
                                    <path id="Path_194430" data-name="Path 194430" d="M18.761,2.5H16.37a.213.213,0,0,1-.217-.208V.833a.87.87,0,0,0-1.739,0V4.792a.653.653,0,0,1-1.3,0V2.917a.426.426,0,0,0-.435-.417H7.239a.213.213,0,0,1-.217-.208V.833a.87.87,0,0,0-1.739,0V4.792a.653.653,0,0,1-1.3,0V2.917A.426.426,0,0,0,3.543,2.5h-1.3A1.7,1.7,0,0,0,.5,4.167V18.333A1.7,1.7,0,0,0,2.239,20H18.761A1.7,1.7,0,0,0,20.5,18.333V4.167A1.7,1.7,0,0,0,18.761,2.5Zm0,15.417a.426.426,0,0,1-.435.417H2.674a.426.426,0,0,1-.435-.417v-10A.426.426,0,0,1,2.674,7.5H18.326a.426.426,0,0,1,.435.417Z" transform="translate(0)" fill="#f64e60" />
                                </g>
                            </svg>

                        </button>

                    </button>
                </div>


                <!--Map View-->

                <div class="mr-2">
                    <button class="btn btn-secondary h-40px ml-2 mb-1" (click)="tabIndex = 2" (click)="mapView()"
                            [ngClass]="{'btn-primary': isMapView == true, 'btn-secondary': isListView == true }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 28.55"
                             class="mr-2">
                            <defs>
                                <style>
                                    .a,
                                    .b {
                                        fill: #fff;
                                        stroke-linecap: round;
                                        stroke-linejoin: round;
                                    }

                                    .a {
                                        stroke: #4c4b5c;
                                    }

                                    .b {
                                        stroke: #6e6e7c;
                                    }
                                </style>
                            </defs>
                            <g transform="translate(-1747.5 -1802.5)">
                                <path class="a"
                                      d="M1767,1812.5c0,5.247-9.5,18.05-9.5,18.05s-9.5-12.8-9.5-18.05a9.5,9.5,0,1,1,19,0Z"
                                      transform="translate(0 0)" />
                                <circle class="b" cx="3.8" cy="3.8" r="3.8" transform="translate(1753.7 1808.7)" />
                            </g>
                        </svg>
                        <span>{{'MapView'|localize}}</span>
                    </button>
                </div>


                <!--List View-->
                <div>
                    <button class="btn h-40px btn-primary mb-1" (click)="tabIndex = 1;listView()"
                            [ngClass]="{'btn-secondary': isMapView == true, 'btn-primary': isListView == true }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" fill="currentColor"
                             class="bi bi-list-ul" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                  d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                        </svg>
                        <span>{{'ListView'|localize}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>










<div id="team-tracking-filter-row" class="px-5 pb-7  d-flex align-items-center flex-wrap sizeSpacing "
     *ngIf="!filterHide">
    <div>
        <div class="dropdown pr-3 " dropdown>
            <button dropdownToggle class="btn btn-outline-secondary btn-icon arrow-box-border h-40px"
                    tooltipPosition="bottom" pTooltip="{{'SortBy'|localize}}">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.916" height="33" viewBox="0 0 14.916 21.616">
                        <g id="Group_112816" data-name="Group 112816" transform="translate(1.058 0.75)">
                            <line id="Line_7" data-name="Line 7" y2="11.786" transform="translate(3.2)" fill="none"
                                  stroke="#b7b7b7" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                            <line id="Line_8" data-name="Line 8" y2="11.786" transform="translate(9.599 8.33)"
                                  fill="none" stroke="#b7b7b7" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="1.5" />
                            <path id="Path_21" data-name="Path 21" d="M1101.4,10153.655l-3.2-3.657-3.2,3.657"
                                  transform="translate(-1095 -10149.995)" fill="none" stroke="#b7b7b7"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                            <path id="Path_22" data-name="Path 22" d="M1115.4,10186l-3.2,3.656L1109,10186"
                                  transform="translate(-1102.6 -10169.542)" fill="none" stroke="#b7b7b7"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                        </g>
                    </svg>
                </span>
            </button>
            <ul class="dropdown-menu" *dropdownMenu id="sortDropDown1">
                <li (click)="newwstOnTop(true)">
                    <a class="p-2 text-dark">{{'NewestOnTop'|localize}}</a>
                </li>
                <li (click)="newwstOnTop(false)">
                    <a class="p-2 text-dark">{{'Oldest On Top'|localize}}</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="flex-grow-1 pr-3 top-filter-div ">
        <div>
            <app-organization-unit-filter [multiselect]="true" [closeOnSelect]="false"
                                          [placeholder]="'FilterByOrganizationUnit'|localize" (changeOrg)="filterbyOrg($event)"
                                          [inputOrgitems]="selectedOrgsDrpDwn"></app-organization-unit-filter>
        </div>
    </div>
    <div class="flex-grow-1 pr-3 top-filter-div ">
        <app-project-filter [multiselect]="true" [closeOnSelect]="false" [placeholder]="'FilterByProject'|localize"
                            [inputProjectitems]="selectedProjectsDrpDwn" (change)="filterByProject($event)"></app-project-filter>
    </div>
    <div class="flex-grow-1 top-filter-div ">
        <app-member-filter [multiselect]="true" [closeOnSelect]="false" [placeholder]="'FilterByUser'|localize"
                           (change)="filterByMember($event)" [inputUseritems]="selectedUsersDrpDwn"></app-member-filter>
    </div>
</div>
